/* BLCKLINE product page additions: sticky add to cart (all screen sizes), Pay in 4 amounts, smooth in-page
   links, "Text us" opens the chat. */
(function () {
  function mainButton() {
    return document.querySelector('product-form form[data-type="add-to-cart-form"] button[type="submit"]') ||
      document.querySelector('product-form form button[name="add"]') ||
      document.querySelector('product-form form button[type="submit"]');
  }

  function mainPrice() {
    var group = document.querySelector('.product-price-group');
    if (!group) return null;
    var nodes = group.querySelectorAll('.money');
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].closest('.compare-at-price')) return nodes[i].textContent.trim();
    }
    return null;
  }

  function initSticky() {
    var bar = document.querySelector('[data-bl-sticky]');
    if (!bar || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    // Fixed positioning breaks inside the theme's sticky product column on desktop: live at <body> level.
    document.body.appendChild(bar);
    var price = bar.querySelector('[data-bl-sticky-price]');
    var btn = bar.querySelector('[data-bl-sticky-btn]');
    var btnLabel = bar.querySelector('[data-bl-sticky-label]');
    var btnPrice = bar.querySelector('[data-bl-sticky-btnprice]');
    var variantEl = bar.querySelector('[data-bl-sticky-variant]');
    var variantJson = bar.querySelector('[data-bl-sticky-variants]');
    var titles = variantJson ? JSON.parse(variantJson.textContent) : {};
    var mainVisible = false;

    // Only write when something changed: the bar sits inside the area being observed.
    function sync() {
      var main = mainButton();
      var p = mainPrice();
      if (p && price.textContent !== p) price.textContent = p;
      if (p && btnPrice && btnPrice.textContent !== '\u00b7 ' + p) btnPrice.textContent = '\u00b7 ' + p;
      var idInput = document.querySelector('product-form form input[name="id"]');
      var vt = idInput && titles[idInput.value];
      if (variantEl && vt && variantEl.textContent !== vt) variantEl.textContent = vt;
      if (main) {
        var label = main.disabled ? 'Sold out' : 'Add to cart';
        if (btn.disabled !== main.disabled) btn.disabled = main.disabled;
        if (btnLabel.textContent !== label) btnLabel.textContent = label;
        if (btnPrice) btnPrice.hidden = main.disabled;
      }
      var show = !mainVisible;
      if (bar.hidden === show) bar.hidden = !show;
      document.body.classList.toggle('bl-sticky-on', show);
    }

    // Match the page's own add to cart button colours (set in the theme editor).
    var mainBtn = mainButton();
    if (mainBtn) {
      var cs = getComputedStyle(mainBtn);
      btn.style.backgroundColor = cs.backgroundColor;
      btn.style.color = cs.color;
    }

    btn.addEventListener('click', function () {
      var main = mainButton();
      if (main && !main.disabled) main.click();
    });

    var main = mainButton();
    if (main && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        mainVisible = entries[0].isIntersecting;
        sync();
      }).observe(main);
    }
    // Variant changes re-render the price and button: keep the bar in step.
    var form = document.querySelector('.product-form-wrapper') || document.body;
    new MutationObserver(function () { sync(); }).observe(form, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    sync();
  }

  // Pay in 4 box: quarter of the selected variant's price, in the same money format as the price.
  function initPay4() {
    var box = document.querySelector('[data-bl-pay4]');
    if (!box || box.dataset.ready) return;
    box.dataset.ready = '1';
    function sync() {
      var p = mainPrice();
      if (!p) return;
      var num = parseFloat(p.replace(/[^0-9.]/g, ''));
      if (isNaN(num)) return;
      var cents = Math.round(num * 100);
      var hide = cents < parseInt(box.dataset.min, 10) || cents > parseInt(box.dataset.max, 10);
      if (box.hidden !== hide) box.hidden = hide;
      var quarter = (Math.round(cents / 4) / 100).toFixed(2);
      var text = p.replace(/[0-9][0-9,]*(\.[0-9]+)?/, quarter.replace(/\B(?=(\d{3})+(?!\d))/g, ',')).replace(/\s*[A-Z]{3}$/, '');
      box.querySelectorAll('[data-bl-pay4-amt]').forEach(function (el) {
        if (el.textContent !== text) el.textContent = text;
      });
    }
    var area = document.querySelector('.product-form-wrapper') || document.body;
    new MutationObserver(sync).observe(area, { subtree: true, childList: true, characterData: true });
    sync();
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-bl-scroll]');
    if (link) {
      var target = null;
      link.dataset.blScroll.split(',').some(function (sel) {
        var el = document.querySelector(sel.trim());
        if (el && el.offsetParent !== null) { target = el; return true; }
        return false;
      });
      if (target) {
        event.preventDefault();
        if (target.tagName === 'DETAILS') target.open = true;  // e.g. "More details about the product"
        var top = target.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
      return;
    }
    // "Text us": open the on-site SMS chat (phones too); only fall back to the sms: link if the widget hasn't loaded.
    var ask = event.target.closest('[data-bl-ask]');
    if (ask) {
      var bubble = document.getElementById('coax-widget-bubble');
      var opener = bubble && (bubble.querySelector('button, [role="button"], img') || bubble);
      if (opener) {
        event.preventDefault();
        opener.click();
      }
    }
  });

  // Trust row pop-ups: <dialog> elements, opened by data-bl-modal, closed by ×, the backdrop or Esc.
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-bl-modal]');
    if (opener) {
      var dialog = document.getElementById(opener.dataset.blModal);
      if (dialog && typeof dialog.showModal === 'function') {
        if (dialog.parentElement !== document.body) document.body.appendChild(dialog);
        dialog.showModal();
      }
      return;
    }
    var pop = event.target.closest('.bl-pop');
    if (pop && (event.target.closest('[data-bl-close]') || event.target === pop)) pop.close();
  });

  // Fitment / What's Included tables: "2010,2011,2012" -> "2010, 2011, 2012"; Yes/No as tick/cross pills.
  function tidyTables() {
    document.querySelectorAll('.bl-fitment td, .bl-included td').forEach(function (td) {
      if (td.dataset.blTidy) return;
      td.dataset.blTidy = '1';
      var text = td.textContent.trim();
      if (/^\d{4}(,\s*\d{4})+$/.test(text)) {
        td.textContent = text.split(/,\s*/).join(', ');
      } else if (/^(yes|no)$/i.test(text)) {
        var yes = /^yes$/i.test(text);
        td.innerHTML = '<span class="bl-pill ' + (yes ? 'bl-pill--yes' : 'bl-pill--no') + '">' + (yes ? '\u2713 Yes' : '\u2715 No') + '</span>';
      }
    });
  }

  function init() { initSticky(); initPay4(); tidyTables(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
